import { isEmpty, isObjectLike } from 'lodash';

import * as DataOrigins from 'commons-vehicle/constants/dataOrigins.js';
import { DRIVE_TRAIN_DATA, DRIVE_TRAIN_4WD } from 'commons-vehicle/constants/dataConversions.js';
import {
    getDescriptionData,
    getModelTrimsBitField,
} from 'commons-vehicle/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js';
import DriveTrainModel from 'commons-vehicle/ModelYear/models/DriveTrainModel.js';
/* eslint import/prefer-default-export: 0 */

function resetDriveTrainFromModelData(modelDriveTrainData) {
    if (modelDriveTrainData.length <= DRIVE_TRAIN_DATA.LONG_DESCRIPTION) {
        return new DriveTrainModel();
    }

    const { trimsBitField, trimsBitFields } = getModelTrimsBitField(modelDriveTrainData[DRIVE_TRAIN_DATA.BIT_FIELD]);

    return new DriveTrainModel({
        trimsBitField,
        trimsBitFields,
        selectionCode: modelDriveTrainData[DRIVE_TRAIN_DATA.ID_CODE],
        code: modelDriveTrainData[DRIVE_TRAIN_DATA.ID_CODE],
        rank: modelDriveTrainData[DRIVE_TRAIN_DATA.CODE] === DRIVE_TRAIN_4WD ? 2 : 1,
        description: getDescriptionData(modelDriveTrainData[DRIVE_TRAIN_DATA.DESCRIPTION]),
        longDescription: getDescriptionData(modelDriveTrainData[DRIVE_TRAIN_DATA.LONG_DESCRIPTION]),
    });
}

export function resetDriveTrainFromOriginData(dataOrigin, originDriveTrainData) {
    if (isEmpty(originDriveTrainData) || !isObjectLike(originDriveTrainData)) {
        return new DriveTrainModel();
    }

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            return new DriveTrainModel();

        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            return resetDriveTrainFromModelData(originDriveTrainData);

        default:
            return new DriveTrainModel();
    }
}

export default {
    resetDriveTrainFromOriginData,
};



// WEBPACK FOOTER //
// ./src/ModelYear/services/DriveTrainService/DriveTrainService.js